import React, { useState } from "react";
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoCloseOutline,
} from "react-icons/io5";
import "./pages.css";
import jazz from "../../assets/jazz.jpg";
import bluss from "../../assets/bluss.jfif";

// Sample data
const courses = [
  {
    id: 1,
    title: "Intro to Jazz Piano",
    description:
      "Learn the fundamentals of jazz piano, including scales, chords, and improvisation techniques.",
    teacher: "Anya K.",
    deadline: "2026-04-15",
    image: jazz,
    registered: true,
    lessons: ["Lesson 1: Basics", "Lesson 2: Scales", "Lesson 3: Chords"],
  },
  {
    id: 2,
    title: "Modern Blues Guitar",
    description:
      "Explore modern blues techniques on guitar, including soloing and rhythm playing.",
    teacher: "John D.",
    deadline: "2026-04-20",
    image: bluss,
    registered: false,
    lessons: [],
  },
];

const truncateText = (text, wordLimit = 20) => {
  const words = text.split(" ");
  if (words.length <= wordLimit) return text;
  return words.slice(0, wordLimit).join(" ") + "...";
};

const Lessons = () => {
  const [expandedCourse, setExpandedCourse] = useState(null);
  const [modalCourse, setModalCourse] = useState(null);

  return (
    <div className="overview-container">
      {courses.length > 0 ? (
        <table className="lessons-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Title</th>
              <th>Description</th>
              <th>Teacher</th>
              <th>Deadline</th>
              <th>Lessons</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {courses.map((course) => (
              <React.Fragment key={course.id}>
                <tr>
                  <td>
                    <img
                      src={course.image}
                      alt={course.title}
                      className="table-course-img"
                      style={{ cursor: "pointer" }}
                      onClick={() => setModalCourse(course)}
                    />
                  </td>
                  <td
                    style={{
                      cursor: "pointer",
                      color: "#4f46e5",
                      fontWeight: 500,
                    }}
                    onClick={() => setModalCourse(course)}
                  >
                    {truncateText(course.title, 6)}
                  </td>
                  <td>{truncateText(course.description, 20)}</td>
                  <td>{course.teacher}</td>
                  <td>{course.deadline}</td>
                  <td>
                    {course.registered && course.lessons.length > 0 ? (
                      <button
                        className="lesson-btn"
                        onClick={() =>
                          setExpandedCourse(
                            expandedCourse === course.id ? null : course.id,
                          )
                        }
                      >
                        {expandedCourse === course.id ? (
                          <IoChevronUpOutline size={18} />
                        ) : (
                          <IoChevronDownOutline size={18} />
                        )}
                      </button>
                    ) : (
                      <span style={{ color: "#ef4444", fontWeight: 500 }}>
                        No Lessons
                      </span>
                    )}
                  </td>
                  <td>
                    {course.registered ? (
                      course.lessons.length > 0 ? (
                        <span style={{ color: "#22c55e", fontWeight: 500 }}>
                          Registered
                        </span>
                      ) : (
                        <button className="dashboard-btn register-btn">
                          Register
                        </button>
                      )
                    ) : (
                      <button className="dashboard-btn register-btn">
                        Register
                      </button>
                    )}
                  </td>
                </tr>

                {/* Expanded Lessons */}
                {expandedCourse === course.id && course.lessons.length > 0 && (
                  <tr className="lessons-row">
                    <td colSpan={7}>
                      <ul className="activities-list">
                        {course.lessons.map((lesson, i) => (
                          <li key={i}>{lesson}</li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      ) : (
        <p>No Courses available</p>
      )}

      {/* Modal for course detail */}
      {modalCourse && (
        <div className="modal-overlay" onClick={() => setModalCourse(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2>{modalCourse.title}</h2>
              <IoCloseOutline
                size={24}
                style={{ cursor: "pointer" }}
                onClick={() => setModalCourse(null)}
              />
            </div>
            <img
              src={modalCourse.image}
              alt={modalCourse.title}
              style={{ width: "100%", borderRadius: "12px", margin: "1rem 0" }}
            />
            <p>{modalCourse.description}</p>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "1rem",
              }}
            >
              <span>Teacher: {modalCourse.teacher}</span>
              <span>Deadline: {modalCourse.deadline}</span>
            </div>
            {modalCourse.lessons.length > 0 && (
              <div style={{ marginTop: "1rem" }}>
                <h4>Lessons</h4>
                <ul className="activities-list">
                  {modalCourse.lessons.map((lesson, i) => (
                    <li key={i}>{lesson}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Lessons;
